import React from 'react';
import CrmInteractionsListPage from './components/CrmInteractionsListPage';

export default function CallsPage() {
  return (
    <CrmInteractionsListPage
      pageKey="callsPage"
      typeFilter="call"
      showPhone
    />
  );
}
